/**
 * Flag de "necesita seleccionar empresa" que vive en sessionStorage.
 *
 * Se setea inmediatamente después de un login exitoso cuando el usuario
 * tiene >1 empresa. Lo lee:
 *   - SelectOrgPage para confirmar que es legítimo estar ahí
 *   - ProtectedRoute para redirigir cualquier intento de saltarse el paso
 *
 * Es sessionStorage (no localStorage) para que se borre al cerrar la
 * pestaña. Si el user lo manipula desde DevTools puede saltarse el paso —
 * acceptable: el JWT que ya tiene es válido para la org default que el
 * backend le asignó. El paso es UX/operativo, no de seguridad.
 */

export const ORG_SELECTION_FLAG = 'taxor_needs_org_selection'

export function markNeedsOrgSelection(): void {
  try {
    sessionStorage.setItem(ORG_SELECTION_FLAG, '1')
  } catch {
    // sessionStorage puede fallar en Safari incógnito; el flag igual
    // se intenta leer con try/catch en los consumers.
  }
}

export function needsOrgSelection(): boolean {
  try {
    return sessionStorage.getItem(ORG_SELECTION_FLAG) === '1'
  } catch {
    return false
  }
}

export function clearOrgSelectionFlag(): void {
  try {
    sessionStorage.removeItem(ORG_SELECTION_FLAG)
  } catch {
    // noop
  }
}
